import React, { useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { ItemSelectableWithOptions } from '../../ItemSelectable/ItemSelectableWithOptions';
import { t } from 'i18next';
import { getTenantInfoByKey } from '../../../helpers/helpers';
import AreasManagementContext from '../../../context/AreasManagementContext/AreasManagementContext';

export const ListOfAreas = ({ area, openWarningModalToDelete }) => {
    const navigate = useNavigate();
    const nameOfArea = getTenantInfoByKey('area_name');

    const { setAreaData } = useContext(AreasManagementContext);

    const goToEditBuilding = async () => {
        await setAreaData(area);
        navigate(`/settings/entityManagment/areasMaganagement/edit/${area.areaId}`);
    }

    const optionsOfAreas = [
        {
            name: `${t('EDIT')} ${nameOfArea}`,
            icon: 'edit-black-icon.svg',
            onClick: () => goToEditBuilding(area),
        },
        {
            name: `${t('DELETE')} ${nameOfArea}`,
            icon: 'trash-bin.svg',
            onClick: () => openWarningModalToDelete(area),
        },
    ]

    return (
        <>
            <ItemSelectableWithOptions options={optionsOfAreas} idPopover={`areaEdit-${area.areaId}`}>
                <div>
                    <p className='m-0 param-section-title'>{`${area.areaCode} - ${area.areaDescription}`}</p>
                    <p className='m-0 mt-1 param-section-subtitle'>{area.Building ? area.Building.buildingDescription : '-'}</p>
                </div>
            </ItemSelectableWithOptions>
        </>

    )
}
